export const getImageSourceUrl = (imageKey?: string | null) => {
  if (!imageKey) return undefined;

  const key = imageKey.replace('public/', '');

  return `https://${process.env.GATSBY_AWS_CLOUDFRONT_DISTRIBUTION}.cloudfront.net/public/${key}`;
};
